'use client';

import { CalendarEvent } from "@/lib/types";
import { collection, orderBy, query } from "firebase/firestore";
import { useMemo } from "react";
import { Calendar } from "@/components/jartinet/calendario/Calendar";
import { db } from "@/firebase/config";
import { sanitizeFirestoreData } from "@/lib/utils";
import { useCollection } from "@/firebase/firestore/use-collection";

export default function CalendarioPage() {
    const eventsQuery = useMemo(
        () => query(collection(db, 'events'), orderBy('start', 'asc')),
        []
    );
    const { data: rawEvents, isLoading } = useCollection<any>(eventsQuery);

    const events: CalendarEvent[] = useMemo(() => {
        if (!rawEvents) return [];
        return rawEvents.map(e => {
            // Sanitiza primero (Timestamps → ISO) y usa el valor saneado para construir
            // las fechas. Antes se hacía `new Date(e.start)` con el valor CRUDO: si el
            // evento guardaba `start` como Timestamp de Firestore → Invalid Date y el
            // evento no se pintaba (por eso salían en admin pero no aquí).
            const s = sanitizeFirestoreData(e) as any;
            return {
                ...s,
                start: new Date(s.start),
                end: new Date(s.end),
            };
        }) as CalendarEvent[];
    }, [rawEvents]);

    return (
        <div className="flex flex-col gap-3 pb-8">
            <div>
                <h1 className="font-headline text-3xl font-bold text-primary">Calendario de Eventos</h1>
                <p className="mt-1 text-sm text-muted-foreground">
                    Consulta las fechas de los próximos eventos. Haz clic en un día para ver todo lo que hay ese día.
                </p>
            </div>
            <div>
                <Calendar
                    events={events}
                    isLoading={isLoading}
                    isEditable={false}
                />
            </div>
        </div>
    );
}
